import { render } from "./FormularioConvenio.vue?vue&type=template&id=c52e0c22&scoped=true"
import script from "./FormularioConvenio.vue?vue&type=script&lang=js"
export * from "./FormularioConvenio.vue?vue&type=script&lang=js"

import "./FormularioConvenio.vue?vue&type=style&index=0&id=c52e0c22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52e0c22"]])

export default __exports__